import React from 'react';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';
import { PaginationPanel } from '~/libs/ui/molecules/PaginationPanel';

import { availabilityGridColumns } from '../constants';
import { AvailabilityListComponentProps } from '../types/AvailabilityListProps';
import { countGroupGridRows } from '../utils/countGroupGridRows';
import { PerPageSelect } from './PerPageSelect';
import { Row } from './Row';
import { TableHeader } from './TableHeader';

export function AvailabilityList({
	data,
	isFetching,
	isError,
	dddShareThreshold,
	selectable,
	selectedIds,
	selectionDisabled,
	onToggleSelect,
	perPage,
	onPageChange,
	onPerPageChange,
	expandedKeys,
	onToggleExpand,
}: AvailabilityListComponentProps) {
	if (isError) {
		return <div className='py-10 text-center text-red-600'>Data se nepodařilo načíst. Zkuste to prosím znovu.</div>;
	}

	if (!data && isFetching) {
		return (
			<div className='flex justify-center py-10'>
				<SpinningLoadingIcon />
			</div>
		);
	}

	if (!data) {
		return null;
	}

	if (data.items.length === 0 && !isFetching) {
		return <div className='py-10 text-center text-gray-500'>Nic nenalezeno.</div>;
	}

	const columns = availabilityGridColumns(selectable);
	let nextRow = 1;

	return (
		<div className={isFetching ? 'opacity-60 pointer-events-none' : undefined}>
			<TableHeader columns={columns} />

			<div className='xl:grid xl:pt-3 xl:gap-y-0' style={{ gridTemplateColumns: columns }}>
				{data.items.map((group, index) => {
					const startRow = nextRow;
					nextRow += countGroupGridRows(group);

					return (
						<Row
							key={group.id}
							group={group}
							dddShareThreshold={dddShareThreshold}
							layout='grid'
							startRow={startRow}
							showGroupSeparator={index > 0}
							selectable={selectable}
							selected={selectedIds.has(group.id)}
							selectionDisabled={selectionDisabled}
							onToggleSelect={onToggleSelect}
							expandedKeys={expandedKeys}
							onToggleExpand={onToggleExpand}
						/>
					);
				})}
			</div>

			<div className='pt-4 flex flex-wrap items-center justify-between gap-4'>
				<PaginationPanel pagination={data.pagination} onChange={onPageChange} />
				<PerPageSelect value={perPage} onChange={onPerPageChange} />
			</div>
		</div>
	);
}
